import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper } from './SectionWrapper';
import { BrainCircuitIcon, ShieldIcon, SparklesIcon } from 'lucide-react';
const steps = [{
  icon: BrainCircuitIcon,
  title: 'Stop Overthinking',
  description: 'Cortocircuitamos el loop de pensamientos antes de que el pánico empiece.'
}, {
  icon: ShieldIcon,
  title: 'Safe Drills',
  description: 'Misiones de 120 segundos que puedes hacer desde tu celular para entrenar tu amígdala.'
}, {
  icon: SparklesIcon,
  title: 'Social Mastery',
  description: 'En el día 14, habitar espacios sociales se siente tan natural como respirar.'
}];
export function MicroExpositionSection() {
  return <SectionWrapper className="bg-cyber-black relative overflow-hidden" data-id="element-367">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-cyber-neon/[0.02] rounded-full blur-[100px]" data-id="element-368"></div>

      <div className="text-center mb-12 relative z-10" data-id="element-369">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-cyber-neon/30 bg-cyber-neon/5 text-cyber-neon font-mono text-xs mb-5" data-id="element-370">
          <span className="w-1.5 h-1.5 rounded-full bg-cyber-neon animate-pulse" data-id="element-371"></span>
          PROTOCOLO ACTIVO
        </div>
        <h2 className="text-2xl md:text-4xl text-white font-mono font-bold" data-id="element-372">
          Micro-Exposición{' '}
          <span className="text-cyber-neon text-shadow-neon" data-id="element-373">Programada</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative z-10" data-id="element-374">
        {steps.map((step, i) => <motion.div key={step.title} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: i * 0.15
      }} className="text-center px-6 py-8 rounded-xl border border-gray-800/60 bg-cyber-dark/40" data-id="element-375">
            <div className="w-14 h-14 rounded-full bg-cyber-neon/10 border border-cyber-neon/40 flex items-center justify-center mx-auto mb-5 shadow-[0_0_20px_rgba(57,255,20,0.08)]" data-id="element-376">
              <step.icon className="w-6 h-6 text-cyber-neon" data-id="element-377" />
            </div>

            <h3 className="text-white font-mono font-bold text-sm mb-3 tracking-wide uppercase" data-id="element-378">
              {step.title}
            </h3>

            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-379">
              {step.description}
            </p>

            {/* Step number */}
            <div className="mt-5 inline-flex items-center gap-1.5 text-[10px] font-mono text-gray-600" data-id="element-380">
              <span className="w-4 h-px bg-gray-700" data-id="element-381"></span>
              PASO {String(i + 1).padStart(2, '0')}
              <span className="w-4 h-px bg-gray-700" data-id="element-382"></span>
            </div>
          </motion.div>)}
      </div>
    </SectionWrapper>;
}